export const BADGETYPE = {
  INFORMATIVE: 'Informative',
  COMMERCIAL: 'Commercial',
  FEATURES: 'Features',
};
